import ViewProfileDialog from './ViewProfileDialog.component';

export default ViewProfileDialog;
